/**
 * TypeEnvoi Object
 */
export class TypeEnvoi {
    /**
     * @param {object} data
     * @param {number=} data.id
     * @param {string=} data.libelle
     * @param {string=} data.dateCreation
     * @param {string=} data.origineCreation
     * @param {string=} data.dateModif
     * @param {string=} data.origineModif
     */
    constructor({
        id = 0,
        libelle = null,
        dateCreation = null,
        origineCreation = null,
        dateModif = null,
        origineModif = null
    } = {}) {
        this.id = id
        this.libelle = libelle
        this.dateCreation = dateCreation ? new Date(dateCreation) : null
        this.origineCreation = origineCreation
        this.dateModif = dateModif ? new Date(dateModif) : null
        this.origineModif = origineModif
    }
}

/**
 * TypeEnvoi Object used to bind error message
 */
export class ErrorTypeEnvoi {
    id
    libelle
    dateCreation
    origineCreation
    dateModif
    origineModif
}